import { render, staticRenderFns } from "./CompetencyAddUpdateModal.vue?vue&type=template&id=9c5f4134&scoped=true"
import script from "./CompetencyAddUpdateModal.vue?vue&type=script&lang=js"
export * from "./CompetencyAddUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./CompetencyAddUpdateModal.vue?vue&type=style&index=0&id=9c5f4134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5f4134",
  null
  
)

export default component.exports